import { TextIcon } from "../../../CommonUI/TextIcon";
import React from "react";
import { BaseJSONXMLElementEditor } from "./BaseJSONXMLElementEditor";
import { JSONXMLNumberElement } from "../../../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLNumberElement";

export class JSONXMLNumberEditor extends BaseJSONXMLElementEditor<JSONXMLNumberElement> {
    getIcon(): JSX.Element {
        return <TextIcon name={"123"} />;
    }
}
